import React, { useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import ContentSkeleton from '../Common/ContentSkeleton';
import { useThemeOptions } from '../Contexts/ThemeOptionsContext';

const Page = React.lazy(() => import('./ContentMain/Page'));
const Videos = React.lazy(() => import('./ContentMain/Videos'));
const Livestream = React.lazy(() => import('./ContentMain/Livestream'));
const VimeoSingle = React.lazy(() => import('./ContentMain/Vimeo/Single'));
const VimeoPlaylist = React.lazy(() => import('./ContentMain/Vimeo/Playlist'));
const VimeoPlaylistArchive = React.lazy(() => import('./ContentMain/Playlists'));

export default function ContentMain() {
	const location = useLocation();
	const assignments = useThemeOptions()?.acf?.page_assignments;
	const playlistSlug = assignments?.course_archive_page?.post_name;
	const livestreamSlug = assignments?.livestream_page?.post_name;
	const className = ['content-area', location.pathname.startsWith('/gold') && 'gold', location.pathname.startsWith('/gold/video/') && 'single'].filter(Boolean).join(' ');
	/*
	useEffect(() => {
		console.log('[ContentMain]', {
			pathname: location.pathname,
			playlistSlug,
			livestreamSlug,
			videoPage: assignments?.video_archive_page?.post_name,
			coursePage: assignments?.course_archive_page?.post_name
		});
	}, [location.pathname, playlistSlug, livestreamSlug, assignments]);
	*/
	const renderRoute = (name, Component) => props => {
		//console.log(`[Route matched] ${name}`, props.location.pathname);
		return <Component {...props} />;
	};

	return (
		<div id="primary" className={className}>
			<main id="main" className="site-main">
				<React.Suspense fallback={<ContentSkeleton spinner />}>
					<Switch>
						<Route exact path="/gold/video/:mediaID" render={renderRoute('Video', VimeoSingle)} />
						<Route exact path="/gold/videos" render={renderRoute('Videos', Videos)} />

						{playlistSlug && <Route exact path={`/gold/${playlistSlug}/:playlistSlug/video/:mediaID`} render={renderRoute('Playlist video', VimeoSingle)} />}
						{playlistSlug && <Route exact path={`/gold/${playlistSlug}/:playlistSlug`} render={renderRoute('Playlist', VimeoPlaylist)} />}
						{playlistSlug && <Route exact path={`/gold/${playlistSlug}`} render={renderRoute('Playlist archive', VimeoPlaylistArchive)} />}

						{livestreamSlug && <Route exact path={`/gold/${livestreamSlug}`} render={renderRoute('Livestream', Livestream)} />}

						<Route exact path="/gold/:slug" render={renderRoute('Page', Page)} />
						<Route exact path="/gold/" render={renderRoute('Gold', Videos)} />
						<Route exact path="/gold" render={renderRoute('Gold', Videos)} />
						<Route exact path="/" render={renderRoute('Root', Videos)} />
					</Switch>
				</React.Suspense>
			</main>
		</div>
	);
}